import { defineMessages } from 'react-intl';

export const i18n: {
	taskStatusFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskStatusFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	taskStatusFilterLabel: {
		id: 'search-page.salesforce.filter.taskStatus',
		defaultMessage: 'Task Status',
		description: 'Label for filtering Salesforce tasks by their status',
	},
	taskStatusFilterNoOptions: {
		id: 'search-page.salesforce.filter.taskStatus.no-options',
		defaultMessage: 'No task statuses available',
		description:
			'Message shown in the Salesforce task status filter dropdown when no status options are available',
	},
});
